/**
 * Skala interfejsu na telefonie przez meta viewport (`initial-scale`).
 *
 * Przegladarka telefonu dostaje szerszy uklad (360 px / 0,8 = 450 px) i pomniejsza
 * cala strone tak jak natywny zoom: tekst, odstepy, rozmiary w px i pozycje
 * popoverow skaluja sie razem, a uklad zostaje mobilny (< md). Przegladarki
 * desktopowe ignoruja meta viewport, a na tablecie (krotszy bok >= 768 px) skala
 * zostaje 1, wiec desktop wyglada jak dotad.
 */

export const UI_SCALES = [1, 0.9, 0.8] as const;
export type UiScale = (typeof UI_SCALES)[number];

/** Domyslna skala telefonu: przy 100% interfejs byl za duzy (S24, 360 px). */
export const DEFAULT_UI_SCALE: UiScale = 0.8;

const STORAGE_KEY = "farmaster-ui-scale";
const PHONE_MAX_SHORT_SIDE = 768;

export function readUiScale(): UiScale {
	const stored = Number(localStorage.getItem(STORAGE_KEY));
	return UI_SCALES.find((scale) => scale === stored) ?? DEFAULT_UI_SCALE;
}

export function storeUiScale(scale: UiScale) {
	localStorage.setItem(STORAGE_KEY, String(scale));
}

/** Telefon po krotszym boku ekranu, niezaleznie od orientacji i biezacego zoomu. */
export function isPhoneScreen(): boolean {
	return Math.min(window.screen.width, window.screen.height) < PHONE_MAX_SHORT_SIDE;
}

export function viewportContent(scale: UiScale): string {
	return `width=device-width, initial-scale=${scale === 1 ? "1.0" : scale}`;
}

export function applyUiScale(scale: UiScale) {
	const meta = document.querySelector('meta[name="viewport"]');
	if (!meta) return;
	meta.setAttribute("content", viewportContent(isPhoneScreen() ? scale : 1));
}
